<!-- js/components/Shared/VueSegmentedControl.vue -->

<template>
    <ul class="segmented-control flex flex-row sm:text-sm border border-gray-300">
        <li
            v-for="(title, index) in options"
            v-bind:key="title"
            @click="updateValue(title, index)"
            class="grow text-center p-2 border-r border-gray-300 last:border-r-0"
            :class="{ 'bg-cal-204285 text-white': selected(title, index) }">{{ title }}</li>
    </ul>
</template>

<script>

export default {

    props: {
        options: {
            default: []
        },
        value: null,
        useIndex: {
            default: false,
        },
        invertIndex: {
            default: false
        },
        allowDeselect: {
            default: true
        }
    },

    methods: {

        updateValue (title, index) {
            let value = null;
            if (this.useIndex) {
                value = this.invertIndex ? this.invert(index) : index;
            }
            else {
                value = title;
            }

            /// If you can deselect, check if same value
            if (this.allowDeselect && value == this.value) {
                value = null;
            }

            this.$emit('input', value);
        },

        selected (title, index) {
            if (this.useIndex) {
                if (this.invertIndex) {
                    index = this.invert(index);
                }
                return index == this.value;
            }
            return title == this.value
        },

        invert (value) {
            return this.options.length - (value+1);
        }
    }
}
</script>
